// extracted by mini-css-extract-plugin
export default {"input_base":"styles_input_base__m7NON"};